function initAddressAutocomplete() {
	'use strict';

	function setInputValueByName(fieldName, value) {
		if (!fieldName) {
			return;
		}

		const $input = $('[name="' + fieldName + '"]');
		$input.val(value || '');
		$input.trigger('change');
	}

	$('[data-address-suggest-action]').each(function() {
		const $streetInput = $(this);

		if ($streetInput.data('address-autocomplete-initialized') === true) {
			return;
		}

		$streetInput.data('address-autocomplete-initialized', true);

		let timeout = null;
		let isSelectingItem = false;
		const $dropdown = $('<div class="address-autocomplete-dropdown"></div>');

		$streetInput.after($dropdown);

		$streetInput.on('input', function() {
			if (isSelectingItem) {
				return;
			}

			const query = String($streetInput.val() || '').trim();

			clearTimeout(timeout);

			if (query.length < 2) {
				$dropdown.empty().hide();
				return;
			}

			timeout = setTimeout(function() {
				$.ajax({
					url: $streetInput.data('address-suggest-action'),
					method: 'GET',
					data: {
						query: query,
					},
					success: function(response) {
						$dropdown.empty();

						if (!response || response.state !== 'success' || !Array.isArray(response.addressList) || !response.addressList.length) {
							$dropdown.hide();
							return;
						}

						$.each(response.addressList, function(_, item) {
							const street = String(item.street || '');
							const houseNumber = String(item.houseNumber || '');
							const city = String(item.city || '');
							const zipCode = String(item.zipCode || '');
							const countryCode = String(item.countryCode || '');

							const titleText = [street, houseNumber].filter(Boolean).join(' ');
							const subtitleText = [city, zipCode].filter(Boolean).join(', ');

							const $item = $('<div class="address-autocomplete-item" role="button" tabindex="0"></div>');
							const $content = $('<div class="address-autocomplete-item-content"></div>');
							const $title = $('<div class="address-autocomplete-item-title"></div>').text(titleText);
							const $subtitle = $('<div class="address-autocomplete-item-subtitle"></div>').text(subtitleText);

							$content.append($title);

							if (subtitleText) {
								$content.append($subtitle);
							}

							$item.append($content);

							$item.on('click keydown', function(event) {
								// TODO DEVDVG-1340 - funguje pouzivani tabulatoru a enter a take varianta shift+tab+enter, ale nefunguje posun nahoru a dolu sipkama na klavesnici
								if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
									return;
								}

								if (event.type === 'keydown') {
									event.preventDefault();
								}

								isSelectingItem = true;
								clearTimeout(timeout);

								$streetInput.val(street).trigger('change');

								setInputValueByName($streetInput.data('address-house-number-name'), houseNumber);
								setInputValueByName($streetInput.data('address-city-name'), city);
								setInputValueByName($streetInput.data('address-zip-code-name'), zipCode);
								setInputValueByName($streetInput.data('address-country-code-name'), countryCode);

								$dropdown.empty().hide();

								setTimeout(function() {
									isSelectingItem = false;
								}, 0);
							});

							$item.appendTo($dropdown);
						});

						$dropdown.show();
					},
					error: function() {
						$dropdown.empty().hide();
					},
				});
			}, 200);
		});

		$(document).on('click', function(event) {
			if (
				!$(event.target).closest($streetInput).length &&
				!$(event.target).closest($dropdown).length
			) {
				$dropdown.empty().hide();
			}
		});
	});
}

window.initAddressAutocomplete = initAddressAutocomplete;